module.exports = __webpack_public_path__ + "static/img4-45eb399e0e9a7b2b7d0abff1b6a0f35d.png";